import React, { createContext, useContext, useState } from 'react';

const EditModeContext = createContext();

export const useEditMode = () => {
    const context = useContext(EditModeContext);
    if (!context) {
        throw new Error('useEditMode must be used within an EditModeProvider');
    }
    return context;
};

export const EditModeProvider = ({ children }) => {
    const [isEditMode, setIsEditMode] = useState(false);

    const enterEditMode = () => {
        setIsEditMode(true);
    };

    const exitEditMode = () => {
        setIsEditMode(false);
    };

    const value = {
        isEditMode,
        enterEditMode,
        exitEditMode,
    };

    return <EditModeContext.Provider value={value}>{children}</EditModeContext.Provider>;
};
